import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { fixTwilioCredentials } from "@/integrations/supabase/fixCredentials";

export const FixCredentialsButton = () => {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleFixCredentials = async () => {
    setLoading(true);
    try {
      // These are the current tenant's credentials from the database
      const tenantId = 'ab858c63-9194-4cdd-94c5-b067aba49d1c';
      const twilioSid = 'ACd1281f3de58805356d77bb10b95c8bed';
      
      // For demonstration, we'll need the actual auth token
      // In a real scenario, you'd get this from a secure input
      const twilioAuthToken = prompt("Please enter your Twilio Auth Token to re-encrypt it:");
      
      if (!twilioAuthToken) {
        toast({
          title: "Auth token required",
          description: "Please provide your Twilio Auth Token to fix the credentials.",
          variant: "destructive",
        });
        return;
      }

      const success = await fixTwilioCredentials(tenantId, twilioSid, twilioAuthToken);
      
      if (success) {
        toast({
          title: "Credentials Fixed",
          description: "Twilio credentials have been re-encrypted and validated successfully.",
        });
      } else {
        toast({
          title: "Failed to Fix Credentials",
          description: "There was an error fixing the Twilio credentials. Check console for details.",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error("Error fixing credentials:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred while fixing credentials.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button 
      onClick={handleFixCredentials} 
      disabled={loading}
      variant="outline"
    >
      {loading ? "Fixing..." : "Fix Twilio Credentials"}
    </Button>
  );
};